import React, { useState } from 'react';

function FAQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      q: 'What does "Gurukulam" mean in a modern software context?',
      a: 'Historically, a Gurukulam was an immersive sanctuary where students learned through direct practice, continuous feedback, and dedicated mentorship. At Durbhasi Gurukulam, we bring this focused apprenticeship philosophy to software engineering: small cohorts of maximum 30 developers, weekly 1:1 pull request reviews, daily architecture office hours, and deep technical mastery.'
    },
    {
      q: 'What is the expected weekly time commitment?',
      a: 'Most developers dedicate 8 to 12 hours per week. This covers 4 hours of live interactive sessions, 4 to 6 hours of hands-on project implementation, and 1 to 2 hours of code review discussion and mentor office hours.'
    },
    {
      q: 'Are live session recordings available if I miss a class?',
      a: 'Yes. All live sessions are recorded in HD quality and published to the Student Portal within 2 hours of completion, along with sample code repositories and architectural diagrams. You also retain lifetime access to the curriculum.'
    },
    {
      q: 'How does the 1-on-1 code review process work?',
      a: 'Each student is assigned a dedicated GitHub repository for their cohort. When you open a pull request for a project milestone, your faculty mentor reviews your code line-by-line, providing feedback on performance, memory efficiency, and structural design before approval.'
    },
    {
      q: 'How do offline classroom batches work at the Jaipur campus?',
      a: 'For select cohorts led by Vikas Kumawat, students can choose the in-person Classroom Batch at our Jaipur Campus (P.No. 18, Radha Vihar, Manchwa, Jaipur). Offline students receive daily in-person lab access, whiteboard design reviews, and direct mentor consultation with UPTO 33% counseling fee concessions.'
    },
    {
      q: 'What support is offered for career advancement?',
      a: 'Students who successfully pass their Capstone Architecture Defense receive 1-on-1 resume reviews, mock technical architecture interviews, and referral opportunities to engineering teams hiring for backend, systems, and cloud roles.'
    }
  ];

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? -1 : idx);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="section-header text-center">
          <div className="section-tag">
            <span className="badge-pill badge-pill-cyan">Frequently Asked Questions</span>
          </div>
          <h2 className="section-title">Cohort &amp; Admission FAQs</h2>
          <p className="section-desc">
            Answers to common questions regarding course format, prerequisites, time commitment, and mentoring.
          </p>
        </div>

        <div className="faq-container">
          {faqs.map((faq, idx) => (
            <div className={`faq-item ${openIndex === idx ? 'open' : ''}`} key={idx}>
              <div
                className="faq-header"
                onClick={() => toggle(idx)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggle(idx); }}
              >
                <span className="faq-question">{faq.q}</span>
                <span className="faq-chevron" style={{ transform: openIndex === idx ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }}>
                  ▼
                </span>
              </div>
              {openIndex === idx && (
                <div className="faq-body">
                  {faq.a}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
